/* projects/portal/src/app/pages/login/login.component.css */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    linear-gradient(
      140deg,
      #2d2926 0%,
      #3f3f3f 60%,
      #4a4441 100%);
}
.login-card {
  width: 100%;
  max-width: 420px;
  background: var(--surface);
  border-radius: 8px;
  padding: 32px;
  border-top: 4px solid var(--primary-color);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.32);
}
.login-lang {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
  margin-bottom: 12px;
}
.login-lang-btn {
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink-muted);
  font: inherit;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3px;
  padding: 4px 9px;
  cursor: pointer;
}
.login-lang-btn:first-child {
  border-radius: 4px 0 0 4px;
}
.login-lang-btn:last-child {
  border-radius: 0 4px 4px 0;
  border-left: none;
}
.login-lang-btn:hover {
  color: var(--ink);
}
.login-lang-active {
  background: var(--canvas);
  color: var(--ink);
  font-weight: 600;
}
.login-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}
.login-logo {
  height: 36px;
  width: auto;
  flex: none;
}
.login-brand h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--ink);
}
.login-brand p {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--ink-muted);
}
.login-field {
  width: 100%;
}
.login-help {
  font-size: 13px;
  color: var(--ink-soft);
  margin: 0 0 14px;
}
.login-msg {
  font-size: 13px;
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 14px;
}
.login-error {
  background: #fbe6e5;
  color: var(--red);
}
.login-info {
  background: #e3f2f1;
  color: #2f6f6a;
}
.login-submit {
  width: 100%;
  height: 44px;
  font-size: 15px;
}
.login-link {
  width: 100%;
  margin-top: 8px;
  color: var(--subheader-color);
}
.login-foot {
  margin: 22px 0 0;
  font-size: 12px;
  color: var(--ink-muted);
  text-align: center;
}
.login-foot a {
  color: #8a5a12;
}
/*# sourceMappingURL=login.component.css.map */
